/** @jsxImportSource @emotion/react */

import { QRCode } from "antd";
import { Fragment, useEffect, useState } from "react";

import { ContactApi } from "api/contact";
import { ContactType } from "types/contact";

import { styles } from "./index.style";
import { buildListServices } from "./list-services";

function CustomerServices() {
    const [contacts, setContacts] = useState<ContactType[]>([]);

  useEffect(() => {
    const handleScroll = () => {
      const currentPosition = window.scrollY;
      const headerPosition = 40 + 65;
      const element = document.getElementById("services");
      if (element) {
        if (currentPosition > headerPosition) {
          element.classList.add("fixed");
        } else {
          element.classList.remove("fixed");
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    let isMounted = true;

    const fetchContacts = async () => {
      try {
        const response = await ContactApi.getContact();

        if (isMounted) {
          setContacts(response.data || []);
        }
      } catch (error) {
        if (isMounted) {
          setContacts([]);
        }
      }
    };

    fetchContacts();

    return () => {
      isMounted = false;
    };
  }, []);

  const listServices = buildListServices(contacts);

  return (
    <Fragment>
      <div id="services" css={styles.index("ct")}>
        <div className="customerServ">
          <ul>
            {listServices.map((item, index) => {
              return (
                <li
                  onClick={() => {
                    if (!item.path || item.disable) return;
                    window.open(item.path);
                  }}
                  key={index}
                  className="Sevli"
                >
                  <div
                    className="icon"
                    style={{ backgroundPosition: item.position }}
                  />
                  <span>{item.name}</span>
                  {item.isQRCode ? (
                    <div className="customerServDiv">
                      <div className="servDivT">
                        {item.name}
                        <div className="rightCsArrow" />
                      </div>
                      <div className="qrImg">
                        {item.path ? (
                          <QRCode
                            bgColor="#fff"
                            value={item.path}
                            className="qr-code"
                            size={85}
                          />
                        ) : null}
                        <span>{item.value}</span>
                      </div>
                    </div>
                  ) : null}
                </li>
              );
            })}
          </ul>
        </div>
        {/* <div className="CF_Gift" css={styles.CF_Gift}>
          <div className="btn_CAO">
            <img
              loading="lazy"
              src={`/ct/desktop/services/icon_CAO.png`}
              alt=""
            />
          </div>
        </div> */}
      </div>
    </Fragment>
  );
}

export default CustomerServices;
